// An externally authored report stored verbatim as HTML (spec 84). The HTML is untrusted: it renders only
// through HtmlVisual's sandbox (opaque origin, no network), never into this document.

import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import Layout from '../Layout';
import HtmlVisual from '../../features/digitalTwin/insight/HtmlVisual';
import { useAuth } from '../../context/AuthContext';
import type { HtmlReportDocument } from '../../types/report';

export function HtmlReportView({ doc }: { doc: HtmlReportDocument }) {
  const { isAdmin } = useAuth();
  const sourceUrl = doc.source?.url;

  return (
    <Layout>
      <div className="mx-auto max-w-[1280px]">
        <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
          <div className="min-w-0">
            <Link
              to="/reports"
              className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-[#0E3B37]"
            >
              <ArrowLeft size={14} /> All reports
            </Link>
            <h1 className="mt-2 text-2xl font-semibold text-[#0E3B37]">{doc.title}</h1>
          </div>
          {isAdmin && sourceUrl && (
            <a
              href={sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-[#0E3B37] hover:border-[#14B8A6]"
            >
              Open original <ExternalLink size={13} />
            </a>
          )}
        </div>
        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
          {doc.html ? (
            <HtmlVisual html={doc.html} />
          ) : (
            <p className="p-8 text-red-600">This report has no content.</p>
          )}
        </div>
      </div>
    </Layout>
  );
}
